import { render, staticRenderFns } from "./ItemCardFrameAssembly.vue?vue&type=template&id=1c202e68&scoped=true"
import script from "./ItemCardFrameAssembly.vue?vue&type=script&lang=ts"
export * from "./ItemCardFrameAssembly.vue?vue&type=script&lang=ts"
import style0 from "./ItemCardFrameAssembly.vue?vue&type=style&index=0&id=1c202e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c202e68",
  null
  
)

export default component.exports